import React from "react";
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import PaginationItem from "@mui/material/PaginationItem";
import Button from "@mui/material/Button";
import styles from './viewSegments.module.scss'
import TextField from "@mui/material/TextField";
import PopoverButton from "../../components/PopverButton";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CustomTable from '../../components/CustomTable'
import initState from '../../utils/stateHandler'
import filterIcon from '../../assets/filterIcon.svg'
import { useDispatch, useSelector } from "react-redux";
import { getSegmentList } from "./viewSegmentsReducer";
import defaults from './constants'
import { showSummaryAction } from "../../components/SegmentSummary/segmentSummaryReducer";
import Skeleton from '@mui/material/Skeleton';
import Typography from "@mui/material/Typography";
import SegmentSummary from "../../components/SegmentSummary";
import { showNavHeadersAction } from "../../components/NavBar/navBarReducer";

const ViewSegments = () => {
    const { rowsPerPage, defaultState, columns } = defaults
    const [state, setters, handlers] = initState("View Campagins")(defaultState)
    const store = useSelector(store => store.segmentList)
    const { showSummary, summary } = useSelector(store => store.segmentSummary)
    const dispatch = useDispatch()

    const count = store.data.length > (rowsPerPage) ? Math.ceil(store.data.length / rowsPerPage) : 0
    const pageFirst = state.page + 1 > 1 ? (state.page * rowsPerPage) + 1 : state.page + 1
    const pageLast = state.page + 1 === count ? store.data.length : (state.page + 1) * rowsPerPage

    const handleChangePage = (e, newPage) => {
        setters.page(newPage - 1)
    }

    const getList = (data) => {
        dispatch(getSegmentList(data))
        setters.disableApply(true)
    }

    const onSegmentSelect = (selectedSegment, index) => {
        dispatch(showSummaryAction(selectedSegment))
        setters.selectedIndex(index)
    }

    const onSearch = () => {
        const body = {
            segmentIds: [],
            segmentNameKeywords: []
        }
        if (state.searchBySegmentId) {
            body.segmentIds.push(state.searchBySegmentId)
        }
        if (state.searchBySegmentName) {
            body.segmentNameKeywords.push(state.searchBySegmentName)
        }
        getList(body)
    }

    const onEnter = (e) => {
        if (e.key === "Enter") {
            onSearch()
        }
    }

    const resetFilters = () => {
        setters.searchBySegmentId("");
        setters.searchBySegmentName("");
        getList()
    }

    const onMenuItemClick = (btn, segment, index) => {
        switch (btn) {
            case "View":
                onSegmentSelect(segment, index)
                break;
        }
    }

    React.useEffect(() => {
        getList()
        dispatch(showNavHeadersAction())
    }, [])
    React.useEffect(() => {
        if (!state.searchBySegmentId && !state.searchBySegmentName) {
            getList()
        }
    }, [state.searchBySegmentId, state.searchBySegmentName])
    return <>
        {showSummary ? <SegmentSummary /> : <Grid className={styles.viewSegmentsContainer} container sx={{ padding: "25px 0px" }}>
            <Grid container item xs={12} justifyContent="space-between">
                <Grid item xs={3}>
                    <TextField InputProps={{
                        classes: {
                            root: styles.search
                        },
                        startAdornment: <img src={filterIcon} width="16px" />
                    }} size="small" fullWidth value={state.searchBySegmentId} onKeyDown={onEnter} onChange={(e) => {
                        setters.disableApply(false)
                        handlers.searchBySegmentId(e)
                    }} placeholder="Search by Segment ID" />
                </Grid>
                <Grid item xs={3}>
                    <TextField InputProps={{
                        classes: {
                            root: styles.search
                        },
                        startAdornment: <img src={filterIcon} width="16px" />
                    }} fullWidth size="small" value={state.searchBySegmentName} onKeyDown={onEnter} onChange={(e) => {
                        setters.disableApply(false)
                        handlers.searchBySegmentName(e)
                    }} placeholder="Search by Segment name" />
                </Grid>
                <Grid item xs={2}>
                    {(state.searchBySegmentId || state.searchBySegmentName) && <Button
                        fullWidth
                        disabled={store.isLoading || state.disableApply}
                        className={styles.buttons}
                        variant='contained'
                        sx={{ color: "#FFF" }}
                        onClick={onSearch}
                    >
                        Apply
                    </Button>}
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                    <Button
                        fullWidth
                        color="error"
                        disabled={!state.searchBySegmentId && !state.searchBySegmentName}
                        className={`${styles.buttons} ${styles.clearBtn}`}
                        variant='contained'
                        sx={{ color: "#FFF" }}
                        onClick={resetFilters}
                    >
                        Clear Filters
                    </Button>
                </Grid>
                <Grid item xs={8} />
                <Grid item container xs={4} justifyContent="flex-end" alignItems="center" marginTop="10px">
                    {store.data?.length > rowsPerPage && <Grid item xs={6} textAlign="right" paddingRight="15px">
                        {`${pageFirst} - ${pageLast} of ${store.data.length}`}
                    </Grid>}
                    <Grid item container xs={6} justifyContent="flex-end">
                        <Pagination
                            classes={{
                                root: styles.paginationContainer
                            }}
                            shape="rounded"
                            variant="outlined"
                            count={count}
                            hideNextButton
                            hidePrevButton
                            page={state.page + 1}
                            renderItem={(item) => <PaginationItem {...item} classes={{
                                root: styles.paginationItem,
                                selected: styles.selectedItem
                            }} />}
                            onChange={handleChangePage}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <CustomTable columns={columns} rows={store.data?.map(((item, index) => ({
                    segmentId: <div className={styles.clickableColumnLink} onClick={() => {
                        onSegmentSelect(item, index)
                    }}>{item.segmentId}</div>,
                    name: item.name,
                    createdBy: item.createdBy,
                    status: item.status,
                    options: <PopoverButton >
                        <List component="div" disablePadding>
                            {defaults.optionsMenu
                                .filter(menuBtn => ((item.status === menuBtn.visibility) || (menuBtn.visibility === "ALL")))
                                .map((menuBtn) => (
                                    <ListItem key={menuBtn.label} disablePadding>
                                        <ListItemButton sx={{ p: "0px 20px" }} onClick={() => {
                                            onMenuItemClick(menuBtn.label, item, index)
                                        }}>
                                            <ListItemText primary={menuBtn.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                        </List>
                    </PopoverButton>
                })))} page={state.page} rowsPerPage={rowsPerPage} rowId="segmentId" />
                {store.isLoading && <>
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                </>}
                {store.error && <Typography component="div" sx={{ textAlign: "center" }}>No data found!</Typography>}
            </Grid>
        </Grid>}
    </>
}

export default ViewSegments;